export default __webpack_public_path__ + "static/media/bla.aa40d79d.svg";